export const mediaFormatDimensions = {
    ['DG_CS']: [700, 500],
    ['DG_IN']: [1080, 1920],
    ['DG_CL']: [1080, 1595],
    ['DG_CSS']: [600, 330],
    ['AGORA_HOL']: [1152, 896]
}